"use client";

import { useEffect } from 'react';
import { setCurrentPageType } from '@utils/utils';

/**
 * Hook to set the current page type in session storage
 * Use this in client components to track which page common modals are opened from
 */
export const usePageType = (pageType: string) => {
  useEffect(() => {
    if (pageType) {
      setCurrentPageType(pageType);
    }
  }, [pageType]);
};

export default usePageType; 